import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { News } from "../../compilers/news/News";
import "../../stylesheet/components/news/NewsCard.scss";
import Skeleton from "react-loading-skeleton";

interface NewsProps {
  news: News;
}

const NewsCard: React.FC<NewsProps> = ({ news }) => {
  const { i18n, ready, t } = useTranslation();
  const getDate = () => {
    const dateArray = news.data.publishDate.split(" ");

    const date = dateArray[1] + " " + dateArray[2] + " " + dateArray[3];
    return <span>{date}</span>;
  };

  return (
    <Link
      className="news-card-wrapper card shadow-sm"
      to={`/${i18n.language}/cafe/news/catalogue/${news.data.slug}`}
    >
      <p className="CTA">{news.data.tags[0]}</p>
      <h5>{news.data.title}</h5>
      <div className="flex-r flex-s-between p2">
        {getDate()}
        <span className="ze-blue">
          <p className="p2 reading-time">
            {Math.ceil(news.data.readingTime.minutes)}{" "}
            {ready ? t("content-card.mins") : <Skeleton width={80} />}
          </p>
        </span>
      </div>
    </Link>
  );
};

export default NewsCard;
